import { render, staticRenderFns } from "./TheEditAttributeForm.vue?vue&type=template&id=60e27cd8&scoped=true&"
import script from "./TheEditAttributeForm.vue?vue&type=script&lang=js&"
export * from "./TheEditAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./TheEditAttributeForm.vue?vue&type=style&index=0&id=60e27cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e27cd8",
  null
  
)

export default component.exports